export const BillHistoryRowCount = 50

export const PAYMENT_TYPE_CODE = {
  PULSA: '01',
  BILLS: '02',
}

export const BILLS_PRODUCT_GROUP_TYPE_CODE = {
  // Bills Payment Type
  PHONE_BILL: '01',
  PLN: '02',

  // PULSA Payment Type
  TELKOMSEL: '11',
  INDOSAT: '12',
  THREE: '13',
  XL: '14',
}

export const BRIDGE_VALUES = {
  VIBRATE_PATTERN: 20
}

export const BILLS_PLN_PRODUCT_TYPE_CODE = {
  PLN_PREPAID: '29001',
  PLN_POSTPAID: '29002',
}

export const EmptyPaymentType: IPaymentType = {
  code: '',
  name: '',
  productGroupTypeList: [],
}

export const EmptyProductGroupType: IProductGroupType = {
  code: '',
  name: '',
  productTypeList: [],
}

export const EmptyProductType: IProductType = {
  code: '',
  name: '',
  switchId: '',
  isAutoFilled: false,
  voucherList: [],
  transactionFee: '0',
}

export const EmptyBill: IBillPaymentInquireResponse = {
  amount: '0',
  customerId: '',
  customerName: '',
  reserved: '',
  fee: '',
  billNum: '',
  tariff: '',
  meterNo: '',
}

export const EmptyBillPaymentPayResponse: IBillPaymentPayResponse = {
  acctCurJan: '',
  custName: '',
  acctTitle: '',
  hisNo: '',
  customerId: '',
  favorite: false,
  fee: '',
  paidAmount: '',
  paidDate: 0,
  productTypeCode: '',
  trxPayKey: 0,
}

export const EmptyBillPaymentRecentAndFavorite: IBillPaymentRecentAndFavorite = {
  acctNo: '',
  customerId: '',
  favorite: false,
  lastUpdatedDate: 0,
  productTypeCode: '',
  productTypeName: '',
  productTypeSwitchId: '',
  trxPayKey: 0,
}

export interface IBillPaymentResultIdentity {
  productTypeCode: string
}

export interface IBillPaymentProductGroupIdentity {
  paymentTypeCode: string
}

export interface IBillPaymentProductIdentity {
  paymentTypeCode: string
  productGroupTypeCode: string
  customerId?: string
}

export interface IBillPaymentAmountIdentity {
  productTypeCode: string
  customerId: string
}

export interface IBillPaymentInquireRequest {
  amount?: string // 지불금액
  customerId: string // 고객번호
  productTypeCode: string // ProductType’s code
  productTypeSwitchId: string // ProductType’s switchId
}

export interface IBillPaymentInquireResponse {
  amount: string // 결제금액
  customerId: string // 고객번호
  customerName: string // 고객이름
  reserved: string // 하나은행쪽 예약값
  fee: string
  billNum: string
  tariff: string
  meterNo: string
}

export interface IBillFormState {
  acctNo: string // 지불 계좌번호
  amount: string // 결제금액
  customerId: string // 고객번호
  reserved: string // 하나은행쪽 예약값
}

export interface IBillPaymentPayRequest extends IBillFormState {
  productTypeCode: string
  productTypeSwitchId: string
}

export interface IBillPaymentPayResponse {
  acctCurJan: string // 현재 계좌 잔고
  custName: string // 고객명
  acctTitle: string // 계좌이름
  hisNo: string // Transaction History No
  customerId: string
  favorite: boolean // 즐겨찾기 여부
  fee: string // 결제 이체 수수료(현 시점에서는 당행 송금으로 처리하여 항상 0으로 반환)
  paidAmount: string // 지불 금액
  paidDate: number // 지불 시각
  productTypeCode: string
  trxPayKey: number // 거래목록 Key
}

export interface IBillPaymentAddFavoriteRequest {
  trxPayKey: number // trxPayKey
}

export interface IBillPaymentRemoveFavoriteRequest {
  trxPayKey: number // trxPayKey
}

export interface IBillPaymentRemoveRecentRequest {
  trxPayKey: number // trxPayKey
}

export interface IProductType {
  code: string
  name: string
  switchId: string
  isAutoFilled: boolean // Auto-Filled 여부
  voucherList: string[]
  transactionFee: string // 수수료
}

export interface IProductGroupType {
  code: string
  name: string
  productTypeList: IProductType[]
}

export interface IPaymentType {
  code: string
  name: string
  productGroupTypeList: IProductGroupType[]
}

export interface IBillPaymentRecentAndFavorite {
  acctNo: string // 지불 계좌번호
  customerId: string // 고객번호
  favorite: boolean
  lastUpdatedDate: number // 최종 변경 일자
  productTypeCode: string // ProductType’s code
  productTypeName: string // ProductType’s name
  productTypeSwitchId: string // ProductType’s switchId
  trxPayKey: number // 거래목록 Key
}

export interface IBillPaymentMainRequest {
  rowCnt: number // 조회할 즐겨찾기 목록의 사이즈
}

export interface IBillPaymentGetCodeResponse {
  paymentTypeList: IPaymentType[]
}

export interface IBillPaymentMainResponse extends IBillPaymentGetCodeResponse {
  favoriteList: IBillPaymentRecentAndFavorite[]
  recentlyList: IBillPaymentRecentAndFavorite[]
}

export interface IBillPaymentGetPulsaProductGroupCodeByPhoneNoRequest {
  phoneNo: string
}

export interface IBillPaymentGetPulsaProductGroupCodeByPhoneNoResponse {
  productGroupTypeCode: string
}
